/**
 * Sort Indicator Component
 *
 * Displays sorting direction indicator on table headers.
 */
import { ArrowUp, ArrowDown, ArrowUpDown } from "lucide-react";
import type { AppHeader } from "../features";
import type { RowData } from "@tanstack/react-table";

type SortIndicatorProps<T extends RowData> = { header: AppHeader<T> };

export const SortIndicator = <T extends RowData>({ header }: SortIndicatorProps<T>) => {
  const sortState = header.column.getIsSorted();

  if (!header.column.getCanSort()) {
    return null;
  }

  return (
    <div className="flex-shrink-0">
      {sortState === "asc"
        ? (
          <ArrowUp size={16} className="text-blue-600" />
        )
        : sortState === "desc"
          ? (
            <ArrowDown size={16} className="text-blue-600" />
          )
          : (
            <ArrowUpDown size={16} className="text-gray-400 opacity-0 group-hover:opacity-100 transition-opacity" />
          )}
    </div>
  );
};
